import axios from "axios";

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_SERVER_URL}`,
    timeout: 300000,
    withCredentials: true,
});

// No Authorization header.
// Browser sends the session cookie automatically when withCredentials is true.
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            // optional: clear local UI state only
            localStorage.removeItem("username");
            localStorage.removeItem("email");
            localStorage.removeItem("role");
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;